function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.44 38.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(15.21 2.53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_Clipping_Path_",
    "data-name": "<Clipping Path>",
    cx: 16.51,
    cy: 16.51,
    r: 16.51,
    transform: "translate(-5.08 25.38) rotate(-67.34)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6",
    "data-name": "Ebene 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Germany"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "German_Flag",
    "data-name": "German Flag"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25.37,
    width: 63.44,
    height: 12.69,
    style: {
      fill: "#f9d300"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12.69,
    width: 63.44,
    height: 12.69,
    style: {
      fill: "#e20e18"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.44,
    height: 12.69,
    style: {
      fill: "#1e1e1c"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangDe);
export default __webpack_public_path__ + "static/media/lang_de.1874724fa637720112cc81cd813dcef5.svg";
export { ForwardRef as ReactComponent };